<script setup lang="ts">
  import type { Component, HTMLAttributes } from "vue";
  import { computed } from "vue";
  import { cn } from "@/lib/utils";

  const props = withDefaults(
    defineProps<{
      title: string;
      description?: string;
      icon?: Component;
      size?: "sm" | "default" | "lg";
      class?: HTMLAttributes["class"];
    }>(),
    {
      description: undefined,
      icon: undefined,
      size: "default",
      class: undefined,
    },
  );

  const paddingClass = computed(() => ({ sm: "py-4", default: "py-8", lg: "py-12" })[props.size]);
  const iconClass = computed(() => (props.size === "sm" ? "w-8 h-8 mx-auto mb-2 opacity-50" : "w-12 h-12 mx-auto mb-3 opacity-50"));
</script>

<template>
  <div :class="cn('text-center text-muted-foreground', paddingClass, props.class)">
    <component
      :is="icon"
      v-if="icon"
      :class="iconClass" />
    <p
      class="text-13"
      :class="{ 'font-medium mb-1': icon || description }">
      {{ title }}
    </p>
    <p
      v-if="description"
      class="text-xs">
      {{ description }}
    </p>
    <div
      v-if="$slots.action"
      class="mt-4">
      <slot name="action" />
    </div>
  </div>
</template>
